import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {ArrowRightCircleIcon, LockIcon} from '@components/ui/icon/Icon.tsx'
import {Button} from '@components/ui/button/Button.tsx'

export const StyledMeasureDetailsContainer = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 6}px;
        height: calc(100vh - 83px);
        background: ${theme.palette.neutral['200']};
        overflow: scroll;

        @media (max-width: 768px) {
            padding: 0;
            height: 100%;
            overflow: scroll;
        }
    `}
`

export const StyledMeasureDetailsWrapper = styled(Flexbox)`
    ${({theme}) => css`
        background: ${theme.palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${theme.shadows.sm};
        border: 1px solid ${theme.palette.neutral['200']};
        height: auto;
        padding: ${theme.spacing * 8}px;

        @media (max-width: 768px) {
            border-radius: 16px;
            padding: ${theme.spacing * 4}px ${theme.spacing * 8}px;
            margin-bottom: ${theme.spacing * 4}px;
        }

        @media (max-width: 380px) {
            padding: ${theme.spacing * 4}px ${theme.spacing * 5}px;
        }
    `}
`

export const StyledCounterPartRow = styled.div`
    ${({theme}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${theme.spacing * 8}px;
        padding: ${theme.spacing * 4}px 0;
        width: 100%;

        & span {
            color: ${theme.palette.neutral['500']};
            ${theme.typography.textSm}
        }

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }
    `}
`

export const StyledContainerInfo = styled.div`
    ${({theme}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: ${theme.spacing * 8}px;
        padding: ${theme.spacing * 4}px 0;
        width: 100%;

        @media (max-width: 768px) {
            grid-template-columns: 1fr 1fr;
        }
    `}
`

export const StyledDetailsTitle = styled.div`
    ${({theme}) => css`
        ${theme.typography.textXl}
        font-weight: 500;
        color: ${theme.palette.neutral['900']};

        & strong {
            font-weight: 700;
            color: ${theme.palette.neutral['black']};
        }
    `}
`

export const StyledLockIcon = styled(LockIcon)`
    ${({theme}) => css`
        fill: none;
        width: 10px;
        height: 10px;
        & path {
            stroke: ${theme.palette.danger['500']};
        }
    `}
`

export const StyledArrowRightCircleIcon = styled(ArrowRightCircleIcon)`
    ${({theme}) => css`
        fill: none;
        & path {
            stroke: ${theme.palette.primary['700']};
        }
    `}
`

export const StyledCounterPartName = styled.div<{$isOmissis: boolean}>`
    ${({$isOmissis, theme}) => css`
        ${$isOmissis &&
        css`
            filter: blur(5px);
        `}
        ${theme.typography.textLg}
        color: ${theme.palette.neutral.black};
        font-weight: 600;
    `}
`

export const StyledSeeMeasureButton = styled(Button)`
    ${() => css`
        padding-left: 0;
    `}
`

export const StyledWarningIsOmissis = styled.div`
    ${({theme}) => css`
        color: ${theme.palette.danger['700']};
        ${theme.typography.textSm}
    `}
`

export const StyledExpandableContainer = styled.div<{$isExpanded: boolean}>`
    position: relative;
    max-height: ${({$isExpanded}) => ($isExpanded ? 'none' : '200px')};
    overflow: hidden;
    width: 100%;
    transition: max-height 0.3s ease-in-out;

    & p {
        ${({theme}) => theme.typography.textSm}

        white-space: pre-line;

        color: ${({theme}) => theme.palette.neutral['500']};
        margin: 0;

        & strong,
        & b {
            font-weight: 600;
            color: ${({theme}) => theme.palette.neutral['900']};
        }
    }
`

export const StyledBlurOverlay = styled.div<{$isExpanded: boolean}>`
    ${({$isExpanded, theme}) => css`
        display: ${$isExpanded ? 'none' : 'block'};
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: linear-gradient(to bottom, transparent, ${theme.palette.neutral.white});
        pointer-events: none;
    `}
`

export const StyledExpandButton = styled(Button)`
    ${({theme}) => css`
        margin-top: ${theme.spacing}px;
        justify-content: center;
        padding: ${theme.spacing}px;
        height: auto;
        min-height: 32px;
        ${theme.typography.textSm}
    `}
`

export const StyledPMQTitle = styled.span`
    ${({theme}) => css`
        ${theme.typography.textSm};
        color: ${theme.palette.neutral['700']};
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
    `}
`

export const StyledDivider = styled.div`
    ${({theme}) => css`
        width: 100%;
        height: 1px;
        background-color: ${theme.palette.neutral['300']};
    `}
`
